import { useEffect } from 'react';

/**
 * Data attribute that triggers rebrand font styles via CSS selector in hbui.
 * @see https://github.com/HoneyBook/hbui/blob/master/src/styles/globals.ts
 */
export const REBRAND_FONTS_DATA_ATTRIBUTE = 'data-rebrand-new-fonts';

/**
 * Controls font switching via feature gate.
 * Sets data-rebrand-new-fonts="true" when enabled, removes when disabled.
 */
export function useFontGateControl(enabled?: boolean) {
    useEffect(() => {
        if (!document?.documentElement) {
            return;
        }

        if (enabled) {
            document.documentElement.setAttribute(REBRAND_FONTS_DATA_ATTRIBUTE, 'true');
        } else {
            document.documentElement.removeAttribute(REBRAND_FONTS_DATA_ATTRIBUTE);
        }
    }, [enabled]);
}
